export default "<button class=\"player__panel-button j-playlist-btn\" title=\"Playlist\">\n  <span class=\"icon-container\"></span>\n</button>\n"